import React, { FC } from 'react';
import { StatusChipType, StatusChip } from '@beeline.com/bp-design-system';
import { StatusModel } from 'src/graphql/types';
import { useCustomFieldsAndObjectsIntl } from '../../translations/useCustomFieldsAndObjectsIntl';

interface Props {
  status: StatusModel | null | undefined;
}

export const ObjectStatus: FC<React.PropsWithChildren<Props>> = ({ status }) => {
  const intl = useCustomFieldsAndObjectsIntl();

  const isActive = status === StatusModel.Active;
  if (!status) return <>-</>;
  return (
    <StatusChip
      label={isActive ? intl.active : intl.inactive}
      type={isActive ? StatusChipType.LIGHT_BLUE : StatusChipType.GREY}
    />
  );
};
